import { call, put, takeLatest } from 'redux-saga/effects';
import * as apollo from 'apollo/leads.query';
import { fetchLeadChecklistTemplates } from 'api/leads';
import { pushSiteError } from 'containers/App/actions';
import * as types from './types';

function* createLeadsStatus(action) {
  try {
    // Create new lead status.
    yield call(apollo.createLeadsStatus, action.payload);
    // #TODO: for now, just refetch statuses. Later need to reduce this properly without a refetch.
    // Re-fetch statuses.
    const results = yield call(apollo.fetchCustomStatuses);
    const payload = results?.data?.getLeadCustomStatuses;
    yield put({ type: types.UPDATE_STATUSES_SUCCESS, payload, actionType: 'create' });
  } catch(err) {
    yield put({ type: types.UPDATE_STATUSES_FAIL });
  }
}

function* updateCustomStatus(action) {
  try {
    const results = yield call(apollo.updateCustomStatus, action.payload);
    const payload = results?.data?.updateLeadCustomStatus;
    yield put({ type: types.UPDATE_STATUSES_SUCCESS, payload, actionType: 'update' });
  } catch (err) {
    yield put({ type: types.UPDATE_STATUSES_FAIL });
  }
}

function* deleteCustomStatus(action) {
  try {
    const results = yield call(apollo.deleteCustomStatus, action.payload);
    const payload = results?.data?.deleteLeadCustomStatus;

    // If visibility is true, then the deletion did not happen.
    if (payload.visibility) throw new Error('Deletion Failed');

    yield put({ type: types.UPDATE_STATUSES_SUCCESS, payload, actionType: 'delete' });
  } catch (err) {
    yield put({ type: types.UPDATE_STATUSES_FAIL });
  }
}

function* reorderStatuses(action) {
  try {
    const { data } = yield call(apollo.reorderLeadStatuses, action.payload);
    if (data?.reorderLeadCustomStatus) {
      const sortedStatuses = data.reorderLeadCustomStatus.sort((a, b) => a.order - b.order);
      yield put({ type: types.REORDER_LEADS_STATUSES_SUCCESS, payload: sortedStatuses });
    }
  } catch (err) {
    yield put({ type: types.REORDER_LEADS_STATUSES_FAIL });
  }
}

// Default Assignments
function* setDefaultAssignment(action) {
  try {
    const results = yield call(apollo.setDefaultLeadAssignment, action.payload);
    const data = results?.data?.setDefaultLeadAssignment;
    yield put({ type: types.UPDATE_DEFAULT_ASSIGNMENTS_SUCCESS, payload: data, action: 'set' });
  } catch (err) {
    yield put({ type: types.UPDATE_DEFAULT_ASSIGNMENTS_FAIL });
  }
}

function* unsetDefaultAssignment(action) {
  try {
    const results = yield call(apollo.unsetDefaultLeadAssignment, action.payload);
    const data = results?.data?.unsetDefaultLeadAssignment;
    yield put({ type: types.UPDATE_DEFAULT_ASSIGNMENTS_SUCCESS, payload: data, action: 'unset' });
  } catch (err) {
    yield put({ type: types.UPDATE_DEFAULT_ASSIGNMENTS_FAIL });
  }
}

// Incoming Notifications
function* addLeadContact(action) {
  try {
    const results = yield call(apollo.addOrgLeadContact, action.payload);
    const data = results?.data?.addOrgMemberLeadContact;
    yield put({ type: types.UPDATE_INCOMING_NOTIFICATION_SUCCESS, payload: data, action: 'set' });
  } catch (err) {
    yield put({ type: types.UPDATE_INCOMING_NOTIFICATION_FAIL });
  }
}

function* deleteLeadContact(action) {
  try {
    const results = yield call(apollo.deleteOrgLeadContact, action.payload);
    const data = results?.data?.deleteOrgMemberLeadContact;
    if (data) yield put({ type: types.UPDATE_INCOMING_NOTIFICATION_SUCCESS, payload: action.payload, action: 'unset' });
  } catch (err) {
    yield put({ type: types.UPDATE_INCOMING_NOTIFICATION_FAIL });
  }
};

function* getLeadChecklistTemplates(action) {
  try {
    const response = yield call(fetchLeadChecklistTemplates, action.payload);
    if (response.ok) {
      yield put({ type: types.ADD_LEAD_CHECKLIST_TEMPLATES, payload: { data: response.data } });
    } else {
      yield put(pushSiteError({ message: "We couldn't get your checklist templates. Please try again." }));
    }
  } catch (err) {
    yield put(pushSiteError({ message: "We couldn't get your checklist templates. Please try again." }));
  }
};

export default function* watchList() {
  yield takeLatest(types.CREATE_LEADS_STATUS, createLeadsStatus);
  yield takeLatest(types.UPDATE_CUSTOM_STATUS, updateCustomStatus);
  yield takeLatest(types.DELETE_CUSTOM_STATUS, deleteCustomStatus);
  yield takeLatest(types.REORDER_LEADS_STATUSES, reorderStatuses);
  yield takeLatest(types.SET_DEFAULT_ASSIGNMENT, setDefaultAssignment);
  yield takeLatest(types.UNSET_DEFAULT_ASSIGNMENT, unsetDefaultAssignment);
  yield takeLatest(types.ADD_LEAD_CONTACT, addLeadContact);
  yield takeLatest(types.DELETE_LEAD_CONTACT, deleteLeadContact);
  yield takeLatest(types.GET_LEAD_CHECKLIST_TEMPLATES, getLeadChecklistTemplates);
}
